define.alias("ember-basic-dropdown/modifiers/basic-dropdown-trigger", "calendar/modifiers/basic-dropdown-trigger");